import React from 'react'

class Chat extends React.Component {
    render(){
        return(
            <div className="chat">
                <div>
                    Chat
                </div>
            </div>
        )
    }
}

export default Chat